"use client";

import { createContext, useState, type JSX, type ReactNode } from "react";

interface NavigationState {
  showLanguage: boolean;
  searchExpanded: boolean;
}

interface NavigationContextValue {
  navigationState: NavigationState;
  setNavigationState: (navigationState: NavigationState) => void;
}

const DEFAULT_STATE: NavigationState = {
  showLanguage: false,
  searchExpanded: false,
};

export const NavigationContext = createContext<NavigationContextValue>({
  navigationState: DEFAULT_STATE,
  setNavigationState: () => {
    throw new Error(
      "setNavigationState called without a NavigationContextProvider in the tree.",
    );
  },
});

interface NavigationContextProviderProps {
  children?: ReactNode;
}

export const NavigationContextProvider = ({
  children,
}: NavigationContextProviderProps): JSX.Element => {
  const [navigationState, setNavigationState] =
    useState<NavigationState>(DEFAULT_STATE);

  return (
    <NavigationContext.Provider value={{ navigationState, setNavigationState }}>
      {children}
    </NavigationContext.Provider>
  );
};
